import { useLanguage, t } from "../../../i18n";
import React from "react";
import { Card, Button } from "react-bootstrap";
import { HiOutlineShieldCheck } from "react-icons/hi";
import { useNavigate } from "react-router-dom";
import ROUTES from "../../../config/routes";
import "./VerificationRequiredState.css";
export default function VerificationRequiredState({
  title = "Verify with Nafath to unlock this feature",
  description = "Complete your one-time Nafath verification to post rooms, manage listings, and unlock contact-based features on BaytBuddy.",
  buttonLabel = "Verify Now"
}) {
  useLanguage();
  const navigate = useNavigate();
  return <Card className="bb-verification-required-card">
      <Card.Body>
        <div className="bb-verification-required-card__icon">
          <HiOutlineShieldCheck />
        </div>

        <h3 className="bb-verification-required-card__title">{t(title)}</h3>

        <p className="bb-verification-required-card__description">
          {t(description)}
        </p>

        <Button className="bb-verification-required-card__btn" onClick={() => navigate(ROUTES.NAFATH_VERIFICATION)}>

          {t(buttonLabel)}
        </Button>
      </Card.Body>
    </Card>;
}
